export const ScheduleStaticData = {
  scheduleText: 'Schedule',
};

export const ScheduleHindiData = {
  scheduleText: 'शेड्यूल',
};

export const ScheduleArabicData = {
  scheduleText: 'الجدولة',
};
